module.exports = __webpack_public_path__ + "static/30-8df04adad347239cf9540b8623896142.png";